import CsvPreviewSrc from '@/assets/svg/csv.svg'
import AviPreviewSrc from '@/assets/svg/avi.svg'
import Mp3PreviewSrc from '@/assets/svg/mp3.svg'
import Mp4PreviewSrc from '@/assets/svg/mp4.svg'
import PdfPreviewSrc from '@/assets/svg/pdf.svg'
import WebmPreviewSrc from '@/assets/svg/webm.svg'
import UnknownPreviewSrc from '@/assets/svg/unknown.svg'

import type { FileProp } from '../model/types'

// Use the LAST dotted segment as the extension — filenames can contain extra dots (e.g.
// "compte_rendu_2024.01.pdf"), so split('.')[1] picked the wrong segment and the preview fell
// through to the "unsupported" viewer.
export const getExtension = (filename: string) => filename.split('.').pop()?.toLowerCase() ?? ''

export const getPreviewSrc = (file: FileProp) => {
  switch (getExtension(file.filename)) {
    case 'jpg':
    case 'jpeg':
    case 'gif':
    case 'bmp':
    case 'png':
      return file.url
    case 'csv':
      return CsvPreviewSrc
    case 'webm':
      return WebmPreviewSrc
    case 'mp4':
      return Mp4PreviewSrc
    case 'avi':
      return AviPreviewSrc
    case 'mp3':
      return Mp3PreviewSrc
    case 'pdf':
      return PdfPreviewSrc
    default:
      return UnknownPreviewSrc
  }
}
